export default __webpack_public_path__ + "static/media/empty-frame.c358ad10.png";